import styled from "@emotion/styled";
import { LightMode } from "@repo/skapa";
import { Variables } from "@repo/skapa";

export const AppointmentContainerBase = styled.div<{
  backgroundColor: string;
  borderColor: string;
  dashed?: boolean;
  selected: boolean;
}>`
  position: relative;
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${({ borderColor }) => borderColor};

  border-radius: ${Variables.radiusS};
  ${({ dashed, borderColor }) =>
    dashed
      ? `
        background-size: 4px 100%, 100% 1px, 1px 100%, 100% 1px;
        background-repeat: no-repeat;
        background-image: repeating-linear-gradient(
          135deg,
          ${borderColor},
          ${borderColor} 3px,
          transparent 3px,
          transparent 6px
      );`
      : ""}
  height: 100%;
  width: 100%;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    border: ${Variables.thicknessThin} solid ${({ borderColor }) => borderColor};
    border-radius: inherit;
    opacity: 0.25;
    pointer-events: none;
  }

  border: ${({ selected }) =>
    selected
      ? `${Variables.thicknessThin} dashed ${LightMode.colourInteractiveEmphasisedBgDefault}`
      : "none"};
`;

export const AppointmentContainer = styled(AppointmentContainerBase)`
  ${({ dashed, borderColor }) =>
    dashed ? "padding-left: 4px;" : `border-left: 4px solid ${borderColor};`}

  ${({ dashed }) =>
    !dashed
      ? `
        &::after {
          left: -4px;
        }
      `
      : ""}

  background-color: ${LightMode.colourStaticWhite};
  box-shadow: ${Variables.shadowSizeDefault};

  ${({ onClick }) =>
    onClick &&
    `&:hover {
        background-color: ${LightMode.colourStaticWhite};
        cursor: pointer;
    }`}
`;
